import { render } from "./TransactionHistoryTableRow.vue?vue&type=template&id=644f5d84&scoped=true"
import script from "./TransactionHistoryTableRow.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryTableRow.vue?vue&type=script&lang=js"

import "./TransactionHistoryTableRow.vue?vue&type=style&index=0&id=644f5d84&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644f5d84"]])

export default __exports__